import client from './client';
import type { ConditionRule, ParsedCondition, Candidate } from '../types';

/**
 * 条件管理 API 封装
 */

/** 获取条件列表 */
export async function fetchConditions(category?: string): Promise<ConditionRule[]> {
  const res = await client.get('/conditions', { params: category ? { category } : {} });
  return res.data;
}

/** 新增条件 */
export async function createCondition(condition: Partial<ConditionRule>): Promise<ConditionRule> {
  const res = await client.post('/conditions', condition);
  return res.data;
}

/** 编辑条件 */
export async function updateCondition(id: number, condition: Partial<ConditionRule>): Promise<ConditionRule> {
  const res = await client.put(`/conditions/${id}`, condition);
  return res.data;
}

/** 删除条件 */
export async function deleteCondition(id: number): Promise<{ id: number }> {
  const res = await client.delete(`/conditions/${id}`);
  return res.data;
}

/** AI 解析自然语言 */
export async function parseCondition(text: string): Promise<ParsedCondition> {
  const res = await client.post('/conditions/parse', { text });
  return res.data;
}

/** 恢复默认预设 */
export async function resetDefaultConditions(): Promise<ConditionRule[]> {
  const res = await client.post('/conditions/reset-defaults');
  return res.data;
}

/** 手动触发筛选
 *  - date?: 不传 → 筛今天（受周末拦截）
 *  - date?: 传历史日 → 按该日的 daily_quotes 重跑，候选写 candidates.date=date
 */
export async function evaluateConditions(date?: string): Promise<Candidate[]> {
  const payload = date ? { date } : null;
  const res = await client.post('/conditions/evaluate', payload, { timeout: 120000 });
  return res.data;
}
